module.exports = __webpack_public_path__ + "media/images/icon-zoom-off-93ca90c7037934e68e5dbce58980294c.svg";